import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminPortal from './AdminPortal';
import './styles/AdminPortal.css';

function AdminPortalApp() {
  // Handle browser back button behavior
  useEffect(() => {
    // Replace the current history state instead of adding to it
    window.history.replaceState({ page: 'admin' }, '', window.location.pathname);
    
    // Push an additional state so there's something in the history
    window.history.pushState({ page: 'admin' }, '', window.location.pathname);
    
    // When the user clicks the browser back button
    const handlePopState = (e) => {
      // If we detect a back navigation
      if (e.state && e.state.page === 'admin') {
        // Stay on the admin page
        // No need to push again since we're just preventing navigation away
      } else {
        // If somehow we got into a different state, push back to admin
        window.history.pushState({ page: 'admin' }, '', window.location.pathname);
      }
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/AdminPortal" element={<AdminPortal />} />
        <Route path="*" element={<Navigate to="/AdminPortal" replace />} />
      </Routes>
    </Router>
  );
}

export default AdminPortalApp; 